import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64966ccf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("发送")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import { number } from "echarts";

interface NoticeVo {
  id: string;
  type: number;
  title: string;
  content: string;
  receiverIds: string;
  receiverName: string;
}

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const ustore = useStore();
const loading = ref(true);

const sendFormData: NoticeVo = {
  id: "",
  type: 5,
  title: "",
  content:"",
  receiverIds: "",
  receiverName: "",
};

const bindData = reactive({
  sendFormData: sendFormData,
  sendFormTitle: "",
});


//新增或更新
const showDialogVisible = ref(false);

const createOrEditHandleCloseEvent = (done: () => void) => {
  done();
};


const showSendNoticeEvent = (receiverId: string, receiverName: string) => {
  showDialogVisible.value = true;
  bindData.sendFormData = {
    id: "",
    type: 5,
    title: "",
    content:"",
    receiverIds: receiverId,
    receiverName: receiverName,
  };
  bindData.sendFormTitle = "发送站内信";
};

const noticeFormRef = ref<FormInstance>();

const validateTilte = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入标题"));
  } else {
    callback();
  }
};

const noticeRules = reactive({
  name: [{ required: true, validator: validateTilte, trigger: "blur" }],
});

const submitNoticeForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch(
          "noticesModule/addNotice",
          bindData.sendFormData
        )
        .then(
          (data) => {
            //成功
            showDialogVisible.value = false;
            ElMessage.success("发送成功");
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => {},
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

expose({
  showSendNoticeEvent
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: showDialogVisible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showDialogVisible).value = $event)),
    title: _unref(bindData).sendFormTitle,
    width: "40%",
    "before-close": createOrEditHandleCloseEvent
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (submitNoticeForm(noticeFormRef.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_unref(ElButton), {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "noticeFormRef",
          ref: noticeFormRef,
          model: _unref(bindData).sendFormData,
          "status-icon": "",
          rules: _unref(noticeRules),
          "label-width": "120px",
          class: "noticeForm"
        }, {
          default: _withCtx(() => [
            (_unref(bindData).sendFormData.receiverName)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "收信人",
                  prop: "code"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(bindData).sendFormData.receiverName), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "标题",
              prop: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).sendFormData.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).sendFormData.title) = $event)),
                  type: "text",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "内容",
              prop: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(bindData).sendFormData.content,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).sendFormData.content) = $event)),
                  type: "textarea",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})